'use client';
import styled from 'styled-components';

export const StyledIllustrationPills = styled.div`
  overflow: scroll;
  width: 100%;
  /* Height & spacing equates to 100px */
  min-height: ${props => props.theme.spacing(25)};
  display: grid;
  align-items: center;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  margin: ${props => props.theme.spacing(4, 0)};
  @media ${props => props.theme.tabletS} {
    margin-bottom: 0;
  }
`;

export const StyledIllustrationPillsCRO = styled.div`
  width: 100%;
  /* Height & spacing equates to 100px */
  min-height: ${props => props.theme.spacing(25)};
  display: grid;
  align-items: center;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  margin: ${props => props.theme.spacing(4, 0)};
  margin-bottom: ${props => props.theme.spacing(11)};
`;

export const Grid = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(2, 1fr);
  gap: ${props => props.theme.spacing(3)};
  margin: auto;
  max-width: 100%;

  @media ${props => props.theme.tabletS} {
    grid-template-columns: repeat(${props => props.gridAmount}, 1fr);
    gap: ${props => props.theme.spacing(3)};
    margin: auto;
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  @media ${props => props.theme.tabletS} {
    display: block;
  }
`;
